import { ChakraBox, ChakraFlex, EquipUITheme } from '@equip.health/ui';

import {
  NOTIFICATION_HEADER_STYLES,
  NotificationEventType,
  NotificationStatus,
} from '~/lib/constants/notifications.constants';
import { getNotificationText } from '~/lib/util/notification.util';

import NotificationAvatar from '../NotificationAvatar';
import NotificationTimeStamp from '../NotificationTimeStamp';

const TOP_LEVEL_ID = 'notification-assessment';

interface NotificationAssessmentProps {
  createdAt?: string;
  eventType?: NotificationEventType;
  isRead?: boolean;
  notificationExternalId?: string;
  onUpdateNotification?: (
    notificationExternalIds: Array<string>,
    status: NotificationStatus,
  ) => void;
  patientName?: string;
}

const { paragraph, paragraphBold } = EquipUITheme.typography;

const NotificationAssessment = ({
  createdAt,
  eventType,
  isRead,
  notificationExternalId,
  onUpdateNotification,
  patientName,
}: NotificationAssessmentProps) => {
  return (
    <ChakraFlex alignItems="start" justifyContent="space-between">
      <NotificationAvatar patientName={patientName} />
      <ChakraBox
        {...paragraph}
        id={`${TOP_LEVEL_ID}-header`}
        {...NOTIFICATION_HEADER_STYLES}
      >
        <span style={{ ...paragraphBold, lineHeight: '16.8px' }}>
          {patientName}
        </span>
        &nbsp;
        <span>{getNotificationText(eventType)}</span>
      </ChakraBox>
      <NotificationTimeStamp
        createdAt={createdAt}
        isRead={isRead}
        notificationExternalId={notificationExternalId}
        onUpdateNotification={onUpdateNotification}
      />
    </ChakraFlex>
  );
};

export default NotificationAssessment;
